export const GET_STATUS_COUNT = 'GET_STATUS_COUNT';
export const GET_STATUS_COUNT_SUCCESS = 'GET_STATUS_COUNT_SUCCESS';
export const GET_STATUS_COUNT_FAIL = 'GET_STATUS_COUNT_FAIL';

export const GET_COLUMN_DATA = 'GET_COLUMN_DATA';
export const GET_COLUMN_DATA_SUCCESS = 'GET_COLUMN_DATA_SUCCESS';
export const GET_COLUMN_DATA_FAIL = 'GET_COLUMN_DATA_FAIL';

export const GET_INVESTIGATION_DATA = 'GET_INVESTIGATION_DATA';
export const GET_INVESTIGATION_SUCCESS = 'GET_INVESTIGATION_SUCCESS';
export const GET_INVESTIGATION_FAIL = 'GET_INVESTIGATION_FAIL';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';

export function getStatusCount(payload) {
  return {
    type: GET_STATUS_COUNT,
    payload
  };
}

export function getStatusCountSuccess(payload) {
  return {
    type: GET_STATUS_COUNT_SUCCESS,
    payload
  };
}

export function getColumnData(payload) {
  return {
    type: GET_COLUMN_DATA,
    payload
  };
}

export function getColumnDataSuccess(payload) {
  return {
    type: GET_COLUMN_DATA_SUCCESS,
    payload
  };
}

export function getInvestigationData(payload) {
  return {
    type: GET_INVESTIGATION_DATA,
    payload
  };
}

export function getInvestigationDataSuccess(payload) {
  return {
    type: GET_INVESTIGATION_SUCCESS,
    payload
  };
}

export function getInvestigationDataFail(payload) {
  return {
    type: GET_INVESTIGATION_FAIL,
    payload
  };
}

export function setCustomDateRange(payload) {
  return {
    type: SET_DATE_RANGE,
    payload
  };
}
